export enum TagEditorMode {
	Full = 0,
	NoAdding = 1,
	NoAssign = 2
}
